import tableTemplate from './reactUserReportsTable.html';
import { reactUserReportCols, defaultSortModel } from './userReportColDefs';
import {ReactTableController} from "../../reactTableController";
import {FILE_TYPE_OPTIONS, statementOptions} from "../../../../views/administration/userReports/UserReportDetailDialogController";
import {BackendService} from "../../../../services/BackendService";
import {ENUMS, USERREPORT_TYPES, userReportfiles, userReports} from "../../../../services/arsweb/RoutingPaths";
import { ADMINISTRATION_USER_REPORTS_TITLE } from '../../../../services/arsweb/TableTitles';
import {SearchableItemService} from "../../../../services/SearchableItemService";
import {ADDROUTE, DELETEROUTE, DELETETITLE} from "../../../../views/administration/userReports/AddUserReportController";
import {EDITTITLE, EDITROUTE} from "../../../../views/administration/userReports/EditUserReportController";
import {ExportService} from "../../../../services/export/ExportService";
import {levelOptionClass} from "../../../../services/arsweb/ClassType";
import {REPORT_TYPE} from "../../../report/ReportModalController";
import { CONSOLIDATION_CURRENCY_PARAMS } from "../../../../controller/CommonViewController";

/** @ngInject */
export function reactUserReportsTable() {
    return {
        restrict: 'E',
        scope: {
            tableId: '@'
        },
        templateUrl: tableTemplate,
        controller: ReactUserReportsTableController,
        controllerAs: 'userReportsTableController'
    };
}

/** @ngInject */
export class ReactUserReportsTableController extends ReactTableController {

    constructor($scope, userService, arsMainDependencies ) {

        super($scope, userService, arsMainDependencies, "", new BackendService(userService), userReports,
            ADMINISTRATION_USER_REPORTS_TITLE, 'userReportsTableParams', "id", false, statementOptions, defaultSortModel);
        this.isUserReport = false;
        this.userService = userService;
        this.exportService = new ExportService(arsMainDependencies.ArsConfig, this.userService);
        this.backendService.service.config.params.filter = {};
        const levelOptionsService = new BackendService(this.userService);
        levelOptionsService.service.config.params.javaType = levelOptionClass;

        const docTypeService = new SearchableItemService(this.userService);

        this.ftsMainDependencies.initCompletedPromise.then(() => this.initGrid(
            docTypeService.backendService.getUserData(USERREPORT_TYPES), levelOptionsService.getUserData(ENUMS)));
    }

    initGrid(docTypesPromise, levelOptionsPromise) {

        this.deleteOption = {
            label: this.translate.instant(DELETETITLE),
            handleAction:() => this.delete(this.gridApi.getSelectedNodes(), DELETEROUTE)};

        this.userService.promise.then(()=> {
            // react user reports  columns
            this.colDefs = reactUserReportCols(this.translate, docTypesPromise, levelOptionsPromise);
			this.initCols();
            // react gridParameters for user reports table
            const userReportGridParams = {
                columnDefs: this.colDefs,
                url: this.backendService.service.getServiceUrl(userReports),
                onAdd: () => this.openModalReact(ADDROUTE),
                rowActions: (row) => {
                    const actions = [];
                    const isActive = row.data.active;
                    if(isActive) {
                        actions.push({
                            label: this.translate.instant('EXECUTE_USERREPORT'),
                            handleAction: () => this.execute([row]),
                        });
                    }
                    if(row.data.owner || row.data.editing === 'PUBLIC') {
                        actions.push({
                            label: this.translate.instant(EDITTITLE),
                            handleAction: (params) => this.openExistingInModal(params.data.id, EDITROUTE),
                        });
                        if(isActive){
                            actions.push({
                                label: this.translate.instant(DELETETITLE),
                                handleAction: (params) => this.deleteRow(params.data.id, params.data.reportName, DELETEROUTE)
                            });
                        }
                    }
                    return actions;
                },
                globalActions: () => this.initCustomGlobalActions(),
                onReport: (selectedNodes) => this.execute(selectedNodes)
            };
            delete this.defaultReactGridParams.onSearchInputChange;
            this.reactGridParams = {...this.defaultReactGridParams, ...userReportGridParams};
        });
    }

    execute(selectedNodes) {
        if(selectedNodes && selectedNodes.length == 1){
            const selectedItem = selectedNodes[0].data;
            if(!selectedItem.active) {
                this.infoPop('ONLY_ACTIVE_ELEMENT_SEL_FOR_EXECUTING');
                return false;
            }
            this.element = selectedNodes[0].data;
            if(this.element.documentType === REPORT_TYPE.XLS_TRANSACTION_REPORT.value) {
                this.element.documentType = REPORT_TYPE.XLSX_TRANSACTION_REPORT.value;
            }

            const fileOptionType = FILE_TYPE_OPTIONS.filter(types =>
                types.options.filter(type => type.value === this.element.documentType)[0])[0]
                .options.filter(opt => opt.value === this.element.documentType)[0];

            this.fileType = this.exportService.processByFileMime(selectedItem, fileOptionType);
            this.executeReport();
        }else if(selectedNodes) {
            this.infoPop('ONLY_ONE_ELEMENT_SEL_FOR_EXECUTING');
            return false;
        }
    }

    executeReport(){
        this.isExecuting = true;
        if(this.backendService.service.config.params[CONSOLIDATION_CURRENCY_PARAMS] &&
            this.backendService.service.config.params[CONSOLIDATION_CURRENCY_PARAMS].code) {
            this.backendService.service.config.params[CONSOLIDATION_CURRENCY_PARAMS] =
                this.backendService.service.config.params[CONSOLIDATION_CURRENCY_PARAMS].code;
        }

        this.promise = this.backendService[this.fileType.userFunction](userReportfiles, this.element)
            .then((data) => {
                this.isExecuting = false;
                this.exportService.downloadFile(data, this.exportService.reportBody.title, this.fileType, this, this.fileType.userFunction);
            }).catch(() => {
                this.isExecuting = false;
                this.errorPop('CREATE_ERROR');
            });
    }

    resetScreen() {
        delete this.element;
        this.backendService = new BackendService(this.userService);
        this.isExecuting = false;
    }

    initCustomGlobalActions() {

        // nothing selected
        if (_.isNil(this.gridApi) || _.isNil(this.gridApi.getSelectedNodes()) || this.gridApi.getSelectedNodes().length === 0) {
            return this.globalActions;
        }

        // delete option only fow owner and non deleted = active
        const allDeletable = this.gridApi.getSelectedNodes().every(rep => rep.data.owner && rep.data.active);
        const index = this.globalActions.indexOf(this.deleteOption);
        if(allDeletable && index === -1) {
            this.globalActions.push(this.deleteOption);
        } else if(!allDeletable && index !== -1) {
            this.globalActions.splice(index, 1);
        }

        return this.globalActions;
    }

    displayElementsForConfirmation() {
        return this.gridApi.getSelectedNodes().map(node => node.data.reportName);
    }
}
